// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1YsdE","productName":"Table_productName__YLYEz"};